export class ScrollConstants {
  static readonly throttle = 300;
  static readonly scrollDistance = 2;
}
